/* eslint-disable */
import axiosIns, {axiosInsNoEnc, axiosDefault} from '@/libs/axios'
import { requestApi, toDecrypt } from '@/libs/secret'
import axios from 'axios'
import store from '..'

export default {
  namespaced: true,
  state: {
    dataCampaign: {
      items: {
        total: 6,
        per_page: 6,
        current_page: 1,
        from: 1,
        to: 6,
        data: [],
      },
      fields: [
        { key: 'campaign_id', label: 'Campaign ID', sortable: true },
        { key: 'creator', label: 'Creator', sortable: true },
        { key: 'campaign_name', label: 'Campaign Name', sortable: true },
        { key: 'company_name', label: 'Company Name', sortable: true },
        { key: 'channel_name', label: 'Channel', sortable: true },
        { key: 'budget', label: 'Budget', sortable: true },
        { key: 'caping_view', label: 'KPI', sortable: true },
        { key: 'method_name', label: 'Buy Method', sortable: true },
        { key: 'start_date', label: 'Start Date', sortable: true },
        { key: 'end_date', label: 'End Date', sortable: true },
        { key: 'status', label: 'Status' },
        { key: 'actions', label: '' },
      ],
      status: [
        {
          1: 'Waiting Approval', 2: 'Approved', 3: 'Rejected',
        },
        {
          1: 'light-warning', 2: 'light-success', 3: 'light-danger',
        },
      ],
      sortBy: '',
      sortDesc: false,
      search: '',
    },
    dataCampaignManage: {
      items: {
        total: 6,
        per_page: 6,
        current_page: 1,
        from: 1,
        to: 6,
        data: [],
      },
      fields: [
        { key: 'checkbox', label: '' },
        { key: 'actions', label: 'Action' },
        { key: 'status', label: 'Status' },
        { key: 'campaign_id', label: 'Campaign ID', sortable: true },
        { key: 'creator', label: 'Creator', sortable: true },
        { key: 'campaign_name', label: 'Campaign Name', sortable: true },
        { key: 'company_name', label: 'Company Name', sortable: true },
        { key: 'channel_name', label: 'Channel', sortable: true },
        // { key: 'budget', label: 'Budget', sortable: true },
        { key: 'caping_view', label: 'KPI', sortable: true },
        // { key: 'total_usage', label: 'Total Usage', sortable: true },
        { key: 'method_name', label: 'Buy Method', sortable: true },
        { key: 'start_date', label: 'Start Date', sortable: true },
        { key: 'end_date', label: 'End Date', sortable: true },
      ],
      status: [
        {
          7: 'All Campaign', 1: 'Waiting Approval', 2: 'Approved', 3: 'Rejected', 4: 'Pause', 5: 'Stop', 6: 'Completed',
        },
        {
          7: 'light-warning', 1: 'light-warning', 2: 'light-success', 3: 'light-danger', 4: 'warning', 5: 'danger', 6: 'info',
        },
      ],
      sortBy: '',
      sortDesc: false,
      search: '',
    },
    dataManageTemplate: {
      items: {
        total: 6,
        per_page: 6,
        current_page: 1,
        from: 1,
        to: 6,
        data: [],
      },
      fields: [
        // { key: 'checkbox', label: '' },
        { key: 'username', label: 'User ID', sortable: true },
        { key: 'templateid', label: 'Template ID', sortable: true },
        { key: 'clientid', label: 'Client ID', sortable: true },
        { key: 'sender', label: 'Sender', sortable: true },
      ],
      sortBy: '',
      sortDesc: false,
      search: '',
    },

    // Template ID
    formTemplate: {
      templateid: "",
      userid: "",
      clientid: "",
      sender: ""
    },
    userTemplateID: [],
    // End Template ID

    formCampaign: {
      company_id: null,
      sender_id: '',
      campaign_name: '',
      default_campaign: 0,
      description: '',
      channel_id: 1,
      method_id: 1,
      currency: '',
      budget: 0,
      status: 1,
      bid_price: 1,
      start_date: '',
      end_date: '',
      forcasted_price: '',
      forcasted_audience: 0,
      forcasted_audience_ioh: 0,
      capping: {
        type: 'by impression',
        value: null,
        limit: 'Per Day',
      },
      scheduling: {
        rate_card_id: null,
        status: 1,
      },
      landscape: null,
      fileVideo: null,
      bannerThumbnail: null,
      potrait: null,
      banner: null,
      icon: null,
      broadcast_image: null,
      delivery_type: 1,
      msisdn_profiling: null,
      upload_msisdn: null,
      content: {},
      targeting: {
        type: '',
        file: null,
        min_age: '18',
        max_age: '55',
        location: [],
        locationProvince: '',
        locationKabupaten: '',
        locationKecamatan: '',
        province: [],
        interest: [],
        gender: ['MALE', 'FEMALE'],
        device: [],
        data_dsv: [],
        min_arpu: '',
        max_arpu: '',
        cem_subs_ctgry: [],
        selectionSegmentsTargeting: {
          selectionUserPersona: [],
          selectionApp: [],
          selectionEngagementbyApp: [],
          selectionVisitor: [],
          selectionCommuter: [],
          selectionNeigbourhoodTier: [],
          selectionPOICategory: [],
        },
        // polygons: {
        //   latlngs: [],
        // },
        polygons: [],
        circle: {
          center: [],
          radius: 1000,
        },
      },
      campaigntype: {
        type: '',
      },
      stateTemplate: [],
      // polygons: {
      //   latlngs: [],
      // },
      // selectionSegmentsTargeting: {
      //   selectionUserPersona: [],
      //   selectionApp: [],
      //   selectionEngagementbyApp: [],
      //   selectionVisitor: [],
      //   selectionCommuter: [],
      //   selectionNeigbourhoodTier: [],
      //   selectionPOICategory: [],
      // },
    },
    bannerLandscapeUrl: '',
    bannerPotraitUrl: '',
    bannerThumbnailUrl: '',
    fileVideoUrl: '',
    bannerIbnUrl: '',
    iconIbnUrl: '',
    imageBimaUrl: '',
    detailCampaign: {},
    dataBudgetUsage: {},
    dataCampaignDashboard: {
      items: {},
      fields: [
        { key: 'campaign_id', label: 'Campaign ID', sortable: true },
        { key: 'campaign_name', label: 'Campaign Name', sortable: true },
        { key: 'status', label: 'Status' },
        { key: 'channel', label: 'Channel', sortable: true },
        { key: 'budget', label: 'Budget', sortable: true },
        { key: 'daily_cap', label: 'KPI', sortable: true },
        { key: 'start_date', label: 'Start Date', sortable: true },
        { key: 'end_date', label: 'End Date', sortable: true },
        { key: 'actions', label: '' },
      ],
      status: [
        {
          1: 'Waiting Approval', 2: 'Approved', 3: 'Rejected',
        },
        {
          1: 'light-warning', 2: 'light-success', 3: 'light-danger',
        },
      ],
    },
    dataCampaignActivity: {
      items: {
        total: 6,
        per_page: 6,
        current_page: 1,
        from: 1,
        to: 6,
        data: [],
      },
      fields: [
        { key: 'clc_date', label: 'Date', sortable: true },
        { key: 'sent', label: 'Sent', sortable: true, sortable: true, thClass: 'd-none', tdClass: 'd-none'},
        { key: 'impression', label: 'Impressions', sortable: true },
        { key: 'click', label: 'Clicks', sortable: true },
        // { key: 'mt', label: 'Sales', sortable: true },
        { key: 'ctr', label: 'CTR', sortable: true },
        // { key: 'cvr', label: 'CVR', sortable: true },
        { key: 'budget_usage', label: 'Cost', sortable: true },
      ],
      status: [
        {
          1: 'Waiting Approval', 2: 'Approved', 3: 'Rejected',
        },
        {
          1: 'light-warning', 2: 'light-success', 3: 'light-danger',
        },
      ],
    },
    campaignId: null,
    campaignDetail: {},
    statusApprove: 1,
    statusCampaign: 7,
    reason: ['ok'],
    listReason: [],
    dailyBudget: [],
    tunnels: [{
      "geometry": {
        "type": "MultiLineString",
        "coordinates": [
          [
            [
              30.348265522849665,
              59.91586313376705
            ],
            [
              30.3539877314681,
              59.91502153293192
            ]
          ],
          [
            [
              30.348374801139254,
              59.915947790658
            ],
            [
              30.35404733780787,
              59.91509623209384
            ]
          ]
        ]
      }
    }],
    statusDSV: [],
  },
  getters: {
    getCampaignItem: state => state.dataCampaign.items,
    getCampaignField: state => state.dataCampaign.fields,
    getCampaignStatus: state => state.dataCampaign.status,
    getCurrentPage: state => state.dataCampaign.items.current_page,
    getSortBy: state => state.dataCampaign.sortBy,
    getSortDesc: state => state.dataCampaign.sortDesc,
    getSearch: state => state.dataCampaign.search,
    getStatusApprove: state => state.statusApprove,

    getCampaignManageItem: state => state.dataCampaignManage.items,
    getCampaignManageField: state => state.dataCampaignManage.fields,
    getCampaignManageStatus: state => state.dataCampaignManage.status,
    getManageCurrentPage: state => state.dataCampaignManage.items.current_page,
    getManageSortBy: state => state.dataCampaignManage.sortBy,
    getManageSortDesc: state => state.dataCampaignManage.sortDesc,
    getManageSearch: state => state.dataCampaignManage.search,
    getStatusCampaign: state => state.statusCampaign,

    // TEMPLATE ID
    getManageTemplateItem: state => state.dataManageTemplate.items,
    getManageTemplateField: state => state.dataManageTemplate.fields,
    getManageTemplateStatus: state => state.dataManageTemplate.status,
    getManageTemplateCurrentPage: state => state.dataManageTemplate.items.current_page,
    getManageTemplateSortBy: state => state.dataManageTemplate.sortBy,
    getManageTemplateSortDesc: state => state.dataManageTemplate.sortDesc,
    getManageTemplateSearch: state => state.dataManageTemplate.search,
    getFormTemplate: state => state.formTemplate,
    // getStatusCampaign: state => state.statusCampaign,
    // END TEMPLATE ID

    getCampaignDashboardItem: state => state.dataCampaignDashboard.items,
    getCampaignDashboardField: state => state.dataCampaignDashboard.fields,
    getCampaignDashboardStatus: state => state.dataCampaignDashboard.status,
    getUserTemplateID: state => state.userTemplateID.data,

    getCampaignActivityItem: state => state.dataCampaignActivity.items,
    getCampaignActivityField: state => state.dataCampaignActivity.fields,
    getActivityCurrentPage: state => state.dataCampaignActivity.items.current_page,
    getActivitySortBy: state => state.dataCampaignActivity.sortBy,
    getActivitySortDesc: state => state.dataCampaignActivity.sortDesc,
    getActivitySearch: state => state.dataCampaignActivity.search,

    getCampaignForm: state => state.formCampaign,
    getCampaignId: state => state.campaignId,
    getDailyBudget: state => state.dailyBudget,
    getCampaignDetail: state => state.campaignDetail,
    getReason: state => state.reason,
    getListReason: state => state.listReason,
    getBannerLandscape: state => state.bannerLandscapeUrl,
    getBannerPotrait: state => state.bannerPotraitUrl,
    getBannerThumbnail: state => state.bannerThumbnailUrl,
    getFileVideo: state => state.fileVideoUrl,
    getBannerIbn: state => state.bannerIbnUrl,
    getIconIbn: state => state.iconIbnUrl,
    getImageBima: state => state.imageBimaUrl,
    getDataDetailCampaign: state => state.detailCampaign,
    getDataBudgetUsage: state => state.dataBudgetUsage,
    getForcastedAudience: state => state.formCampaign.forcasted_audience,
    getForcastedAudienceIOH: state => state.formCampaign.forcasted_audience_ioh,
    getStatusDataDsv: state => {return state.statusDSV},
    getCampaignTypes : state => state.formCampaign.campaigntype.type,
    getTargetingTypes : state => state.formCampaign.targeting.type,
  },
  mutations: {
    SET_RATE_CARD: (state, value) => (value ? (state.formCampaign.scheduling.rate_card_id = value) : (state.formCampaign.scheduling.rate_card_id = null)),
    SET_FORM: (state, value) => (value ? (state.formCampaign = value) : (state.formCampaign = {})),
    SET_BANNER_LANDSCAPE_URL: (state, value) => (value ? (state.bannerLandscapeUrl = value) : (state.bannerLandscapeUrl = '')),
    SET_BANNER_POTRAIT_URL: (state, value) => (value ? (state.bannerPotraitUrl = value) : (state.bannerPotraitUrl = '')),
    SET_BANNER_THUMBNAIL_URL: (state, value) => (value ? (state.bannerThumbnailUrl = value) : (state.bannerThumbnailUrl = '')),
    SET_FILE_VIDEO_URL: (state, value) => (value ? (state.fileVideoUrl = value) : (state.fileVideoUrl = '')),
    SET_BANNER_IBN_URL: (state, value) => (value ? (state.bannerIbnUrl = value) : (state.bannerIbnUrl = '')),
    SET_ICON_IBN_URL: (state, value) => (value ? (state.iconIbnUrl = value) : (state.iconIbnUrl = '')),
    SET_IMAGE_BIMA_URL: (state, value) => (value ? (state.imageBimaUrl = value) : (state.imageBimaUrl = '')),
    SET_DETAIL_CAMPAIGN: (state, value) => (value ? (state.campaignDetail = value) : (state.campaignDetail = {})),
    SET_BUDGET_USAGE: (state, value) => (value ? (state.dataBudgetUsage = value) : (state.dataBudgetUsage = {})),
    SET_CAMPAIGN_ID: (state, value) => (value ? (state.campaignId = value) : (state.campaignId = '')),
    SET_REASON: (state, value) => (value ? (state.reason = value) : (state.reason = [])),
    SET_LIST_REASON: (state, value) => (value ? (state.listReason = value) : (state.listReason = [])),
    SET_STATUS_APPROVE: (state, value) => (value ? (state.statusApprove = value) : (state.statusApprove = 1)),
    SET_FOR_AUDIENCE: (state, value) => (value ? (state.formCampaign.forcasted_audience = value) : (state.formCampaign.forcasted_audience = 0)),

    SET_DATA_CAMPAIGN_DASHBOARD_ITEM: (state, value) => (value ? (state.dataCampaignDashboard.items = value) : (state.dataCampaignDashboard.items = {})),
    SET_DATA_CAMPAIGN_DASHBOARD_FORM: (state, value) => (value ? (state.dataCampaignDashboard.form = value) : (state.dataCampaignDashboard.form = {})),

    SET_DATA_CAMPAIGN_ITEM: (state, value) => (value ? (state.dataCampaign.items = value) : (state.dataCampaign.items = {})),
    SET_DATA_CAMPAIGN_FORM: (state, value) => (value ? (state.dataCampaign.form = value) : (state.dataCampaign.form = {})),
    SET_LIST_CURRENT_PAGE: (state, value) => (value ? (state.dataCampaign.items.current_page = value) : (state.dataCampaign.items.current_page = 1)),
    SET_LIST_SORT_BY: (state, value) => (value ? (state.dataCampaign.sortBy = value) : (state.dataCampaign.sortBy = '')),
    SET_LIST_SORT_DESC: (state, value) => (value ? (state.dataCampaign.sortDesc = value) : (state.dataCampaign.sortDesc = false)),
    SET_LIST_SEARCH: (state, value) => (value ? (state.dataCampaign.search = value) : (state.dataCampaign.search = '')),
    SET_ITEM_DATA: (state, value) => (value ? (state.dataCampaign.items.data = value) : (state.dataCampaign.items.data = [])),

    SET_DATA_CAMPAIGN_MANAGE_ITEM: (state, value) => (value ? (state.dataCampaignManage.items = value) : (state.dataCampaignManage.items = {})),
    SET_DATA_CAMPAIGN_MANAGE_FORM: (state, value) => (value ? (state.dataCampaignManage.form = value) : (state.dataCampaignManage.form = {})),
    SET_MANAGE_CURRENT_PAGE: (state, value) => (value ? (state.dataCampaignManage.items.current_page = value) : (state.dataCampaignManage.items.current_page = 1)),
    SET_MANAGE_SORT_BY: (state, value) => (value ? (state.dataCampaignManage.sortBy = value) : (state.dataCampaignManage.sortBy = '')),
    SET_MANAGE_SORT_DESC: (state, value) => (value ? (state.dataCampaignManage.sortDesc = value) : (state.dataCampaignManage.sortDesc = false)),
    SET_MANAGE_SEARCH: (state, value) => (value ? (state.dataCampaignManage.search = value) : (state.dataCampaignManage.search = '')),
    SET_ITEM_DATA_MANAGE: (state, value) => (value ? (state.dataCampaignManage.items.data = value) : (state.dataCampaignManage.items.data = [])),

    // Setter TemplateID
    SET_DATA_TEMPLATE_MANAGE_ITEM: (state, value) => (value ? (state.dataManageTemplate.items = value) : (state.dataManageTemplate.items = {})),
    SET_DATA_TEMPLATE_MANAGE_FORM: (state, value) => (value ? (state.dataManageTemplate.form = value) : (state.dataManageTemplate.form = {})),
    SET_MANAGETEMPLATE_CURRENT_PAGE: (state, value) => (value ? (state.dataManageTemplate.items.current_page = value) : (state.dataManageTemplate.items.current_page = 1)),
    SET_MANAGETEMPLATE_SORT_BY: (state, value) => (value ? (state.dataManageTemplate.sortBy = value) : (state.dataManageTemplate.sortBy = '')),
    SET_MANAGETEMPLATE_SORT_DESC: (state, value) => (value ? (state.dataManageTemplate.sortDesc = value) : (state.dataManageTemplate.sortDesc = false)),
    SET_MANAGETEMPLATE_SEARCH: (state, value) => (value ? (state.dataManageTemplate.search = value) : (state.dataManageTemplate.search = '')),
    SET_ITEM_DATA_TEMPLATEMANAGE: (state, value) => (value ? (state.dataManageTemplate.items.data = value) : (state.dataManageTemplate.items.data = [])),
    SET_TEMPLATE_USERID:  (state, value) => (value ? (state.userTemplateID = value) : (state.userTemplateID = [])),
    SET_RESETFORM_TEMPLATE: (state, value) => (value ? (state.formTemplate = value) : (state.formTemplate = {})),
    // Setter TemplateID

    SET_CAMPAIGN_ACTIVITY_ITEM: (state, value) => (value ? (state.dataCampaignActivity.items = value) : (state.dataCampaignActivity.items = {})),
    SET_ACTIVITY_CURRENT_PAGE: (state, value) => (value ? (state.dataCampaignActivity.items.current_page = value) : (state.dataCampaignActivity.items.current_page = 1)),
    SET_ACTIVITY_SORT_BY: (state, value) => (value ? (state.dataCampaignActivity.sortBy = value) : (state.dataCampaignActivity.sortBy = '')),
    SET_ACTIVITY_SORT_DESC: (state, value) => (value ? (state.dataCampaignActivity.sortDesc = value) : (state.dataCampaignActivity.sortDesc = false)),
    SET_ACTIVITY_SEARCH: (state, value) => (value ? (state.dataCampaignActivity.search = value) : (state.dataCampaignActivity.search = '')),
    SET_ITEM_DATA_ACTIVITY: (state, value) => (value ? (state.dataCampaignActivity.items.data = value) : (state.dataCampaignActivity.items.data = [])),
    SET_DAILY_BUDGET: (state, value) => (value ? (state.dailyBudget = value) : (state.dailyBudget = [])),
    SET_STATUS_CAMPAIGN: (state, value) => (value ? (state.statusCampaign = value) : (state.statusCampaign = null)),
    // SET_FILE_UPLOAD: (state, value) => (value ? (state.upload_msisdn = value) : (state.upload_msisdn = null)),

    SET_FORCASTED_IOH: (state, value) => (value ? (state.formCampaign.forcasted_audience_ioh = value) : (state.formCampaign.forcasted_audience_ioh = 0)),
    SET_DSVDATA_IOH: (state, value) => (value ? (state.formCampaign.targeting.data_dsv = value) : (state.formCampaign.targeting.data_dsv = [])),
    SET_STATUSDSVDATA_IOH: (state, value) => (value ? (state.statusDSV = value) : (state.statusDSV = [])),
    SET_STATUSDATADSV: (state, value) => (value ? (state.statusDSV = []) : (state.statusDSV = [])),
  },
  actions: {
    clearTable({ commit }) {
      commit('SET_LIST_CURRENT_PAGE')
      commit('SET_LIST_SORT_BY')
      commit('SET_LIST_SORT_DESC')
      commit('SET_LIST_SEARCH')

      commit('SET_MANAGE_CURRENT_PAGE')
      commit('SET_MANAGE_SORT_BY')
      commit('SET_MANAGE_SORT_DESC')
      commit('SET_MANAGE_SEARCH')

      commit('SET_ACTIVITY_CURRENT_PAGE')
      commit('SET_ACTIVITY_SORT_BY')
      commit('SET_ACTIVITY_SORT_DESC')
      commit('SET_ACTIVITY_SEARCH')
    },
    getCampaignActivity: ({ commit, getters, rootState }) => {
      const desc = (getters.getSortDesc) ? 'desc' : 'asc'
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      commit('SET_ITEM_DATA')
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(`page=${getters.getActivityCurrentPage}&filter=${getters.getActivitySearch}&sortby=${getters.getActivitySortBy}&sortdir=${desc}`)
        axiosIns.get(`/campaign/dailyBudgetUsage/${getters.getCampaignId}?req=${queryParam.req}`, { headers })
          .then(response => {
            const newData = response.data
            commit('SET_CAMPAIGN_ACTIVITY_ITEM', newData)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getCampaignBudget: ({ commit, rootState }, payload) => {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get(`/campaign/dailyBudgetUsage/${payload}/graph`, { headers })
          .then(response => {
            const newData = response.data.data
            commit('SET_DAILY_BUDGET', newData)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getCampaignDetailList: ({ commit, rootState }, payload) => {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get(`/campaign/campaignDetail/${payload}`, { headers })
          .then(response => {
            const newData = response.data.data
            commit('SET_DETAIL_CAMPAIGN', newData)
            // console.log(newData, 'setailDta')
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getCampaignApprove({ commit, getters, rootState }) {
      const desc = (getters.getSortDesc) ? 'desc' : 'asc'
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      commit('SET_ITEM_DATA')
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(`page=${getters.getCurrentPage}&filter=${getters.getSearch}&sortby=${getters.getSortBy}&sortdir=${desc}&status=${getters.getStatusApprove}`)
        axiosIns.get(`/campaign/campaignApprovalList?req=${queryParam.req}`, { headers })
          .then(response => {
            const newData = response.data
            commit('SET_DATA_CAMPAIGN_ITEM', newData)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getCampaignManage({ commit, getters, rootState }) {
      const desc = (getters.getManageSortDesc) ? 'desc' : 'asc'
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      commit('SET_ITEM_DATA_MANAGE')
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(`page=${getters.getManageCurrentPage}&filter=${getters.getManageSearch}&sortby=${getters.getManageSortBy}&sortdir=${desc}&status=${getters.getStatusCampaign}`)
        axiosIns.get(`/campaign/manageCampaign?req=${queryParam.req}`, { headers })
          .then(response => {
            const newData = response.data
            commit('SET_DATA_CAMPAIGN_MANAGE_ITEM', newData)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getBudgetUsage({ commit, getters, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      const sendData = {
        campaig_id: getters.getCampaignId,
      }
      return new Promise((resolve, reject) => {
        axiosIns.post('/campaign/dailyBudgetUsage', sendData, { headers })
          .then(response => {
            commit('SET_BUDGET_USAGE', response.data)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    createCampaign({ rootState }, payload) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      const sendData = payload
      return new Promise((resolve, reject) => {
        axiosInsNoEnc.post('/campaign/create', sendData, { headers })
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    updateDefaultCampaign({ rootState }, payload) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      const sendData = payload
      return new Promise((resolve, reject) => {
        axiosIns.post('/campaign/updateDefault', sendData, { headers })
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    resetForm({ commit, getters }) {
      const resetForm = {
        company_id: null,
        campaign_name: '',
        default_campaign: 0,
        description: '',
        channel_id: 1,
        method_id: 1,
        currency: '',
        budget: 0,
        status: 1,
        bid_price: 1,
        start_date: '',
        end_date: '',
        forcasted_price: '',
        forcasted_audience: 0,
        capping: {
          type: 'by impression',
          value: null,
          limit: 'Per Day',
        },
        scheduling: {
          rate_card_id: null,
          status: 1,
        },
        landscape: null,
        potrait: null,
        msisdn_profiling: null,
        content: {},
        targeting: {
          type: getters.getTargetingTypes,
          file: null,
          min_age: '18',
          max_age: '55',
          location: [],
          locationProvince: '',
          locationKabupaten: '',
          locationKecamatan: '',
          interest: [],
          gender: ['MALE', 'FEMALE'],
          device: [],
          data_dsv: [],
          min_arpu: '',
          max_arpu: '',
          cem_subs_ctgry: ['SUB_PROF_MUSIC'],
          selectionSegmentsTargeting: {
            selectionUserPersona: [],
            selectionApp: [],
            selectionEngagementbyApp: [],
            selectionVisitor: [],
            selectionCommuter: [],
            selectionNeigbourhoodTier: [],
            selectionPOICategory: [],
          },
          polygons: [],
          circle: {
            center: [],
            radius: 1000,
          },
        },
        campaigntype: {
          type: getters.getCampaignTypes,
        },
        stateTemplate: [],
      }
      commit('SET_FORM', resetForm)
      commit('SET_STATUSDATADSV')
      commit('SET_BANNER_LANDSCAPE_URL')
      commit('SET_BANNER_POTRAIT_URL')
    },
    approveCampaign({ commit, getters, rootState }) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      const sendData = {
        campaign_id: getters.getCampaignId,
        reason: getters.getReason,
        status: getters.getStatusApprove,
      }
      return new Promise((resolve, reject) => {
        axiosIns.post('/campaign/approval', sendData, { headers })
          .then(response => {
            commit('SET_CAMPAIGN_ID', getters.getClientId)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    actionCampaign({ rootState }, payload) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      const sendData = {
        campaign_id: payload.campaignId,
        reason: [],
        status: payload.status,
      }
      return new Promise((resolve, reject) => {
        axiosIns.post('/campaign/action', sendData, { headers })
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    listReason({ commit, rootState }) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get('/reason/type/2', { headers })
          .then(response => {
            commit('SET_LIST_REASON', response.data.data)
            resolve(response.data.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    setForcastedAudience({ commit, getters, rootState }, payload) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      const sendData = getters.getCampaignForm.targeting
      const queryParam = requestApi(`channel=${payload}`)
      return new Promise((resolve, reject) => {
        axiosIns.post(`/campaign/forcastedTargetAudience?req=${queryParam.req}`, sendData, { headers })
          .then(response => {
            commit('SET_FOR_AUDIENCE', response.data.data.forecastTarget)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    downloadTable({ getters, rootState }, payload) {
      const desc = (getters.getManageSortDesc) ? 'desc' : 'asc'
      const user = rootState.auth.userData.data.id
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(`user=${user}&filter=${getters.getManageSearch}&sortby=${getters.getManageSortBy}&sortdir=${desc}&status=${getters.getStatusCampaign}&type=${payload}`)
        axiosDefault.get(`/campaign/download?req=${queryParam.req}`, { headers, responseType: 'blob' })
          .then(response => {
            // const newData = response.data
            // let blob = new Blob([response.data], { type: 'application/pdf' }),
            // url = window.URL.createObjectURL(blob)
            // window.open(url)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    setForcastedAudienceIOH({ commit, getters, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      const sendData = getters.getCampaignForm.targeting
      return new Promise((resolve, reject) => {
        axios
          .post(`${process.env.VUE_APP_BASE_URLS}iohforcasting`, sendData, {headers})
          .then((response) => {
            let ecr = toDecrypt(response.data.res, store.state.secretKey)
            const dataResponForcasted = JSON.parse(ecr)
            commit('SET_FORCASTED_IOH', Number(dataResponForcasted.original.data))
            resolve(Number(dataResponForcasted.original.data))
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    setGetParamsDSV({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axiosIns.get('/dsvforcasting', { headers })
          .then(response => {
            commit('SET_STATUSDSVDATA_IOH', response.data)
            commit('SET_DSVDATA_IOH', response.data.data)
            resolve(response.data.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    
    // GET AND CREATE TEMPLATE
    setTemplateUserID({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        // const queryParam = requestApi(`page=${getters.getManageCurrentPage}&filter=${getters.getManageSearch}&sortby=${getters.getManageSortBy}&sortdir=${desc}&status=${getters.getStatusCampaign}`)
        axiosIns.get(`/findAllUsers`, { headers })
        .then(response => {
          // console.log(response);
          const newData = response.data
          commit('SET_TEMPLATE_USERID', newData)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    setTemplateManage({ getters, commit, rootState }) {
      const desc = (getters.getManageSortDesc) ? 'desc' : 'asc'
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      const dataMustBeSend = {
        campaign_id: [],
        start_date: "",
        end_date: "",
        channel: [],
        method: [],
        company: [],
        search: ""
      }
      commit('SET_ITEM_DATA_TEMPLATEMANAGE')
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(`page=${getters.getManageTemplateCurrentPage}&filter=${getters.getManageTemplateSearch}&sortby=${getters.getManageTemplateSortBy}&sortdir=${desc}`)
        axiosIns.post(`/campaign/smspremiumtemplate?req=${queryParam.req}`, dataMustBeSend, { headers })
        // axios.post(`https://62a8ddc7ec36bf40bdafa633.mockapi.io/create_template`,  {headers})
        .then(response => {
          // console.log(response.data);
          const newData = response.data
          commit('SET_DATA_TEMPLATE_MANAGE_ITEM', newData)
          // commit('SET_ITEM_DATA_TEMPLATEMANAGE', newData)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    createTemplateID({ getters, commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      const sendDataTemplate = getters.getFormTemplate
      return new Promise((resolve, reject) => {
        axiosInsNoEnc.post(`/campaign/createtemplate`, sendDataTemplate, {headers})
        .then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    resetFormTemplateID({ commit }) {
      const resetForm = {
        templateid: "",
        userid: "",
        clientid: "",
        sender: ""
      }
      commit('SET_RESETFORM_TEMPLATE', resetForm)
    },
  },
}
